import { requestFile } from '../@utils'
import { request } from '../@utils'
const PurchaseReturnService = {
  getList: params => {
    return request.post('purchase-return/list', {
      data: params
    })
  },
  getInfoById: id => {
    return request.get(`purchase-return/info/${id}`)
  },
  billsDiscard: (ids = []) => {
    return request.post(`purchase-return/bills-discard`, { data: { ids } })
  },
  getDetailProductList: data => {
    return request.post(`purchase-return/detail/list`, { data })
  },
  createBill: data => {
    return request.post(`purchase-return/create`, { data })
  },
  export: data => {
    return requestFile.post(`purchase-return/export`, {
      data: data,
      responseType: 'blob'
    })
  },
  markPayStatus: data => {
    return request.post(`purchase-return/mark-pay-status`, { data })
  },
  getCountMoney: data => {
    return request.post(`purchase-return/count-money`, { data })
  },
  getRefCostPrice: data => {
    return request.post(`purchase-return/product-details`, { data })
  }
}

export default PurchaseReturnService
